import Dictionary from '@/model/resource/Dictionary'

export default new class {
  constructor () {
    this.tooltips = {}
  }

  load (doneCallback, errorCallback) {
    var locale = {}
    Dictionary
      .get()
      .then(response => {
        for (var i = 0; i < response.data.length; i++) {
          var item = response.data[i]
          if (!locale.hasOwnProperty(item.lang)) {
            locale[item.lang] = {}
            this.tooltips[item.lang] = {}
          }
          locale[item.lang][item.dictionarykey] = item.value
          this.tooltips[item.lang][item.dictionarykey] = item.toolTip
        }

        doneCallback(locale)
      })
      .catch(error => {
        if (errorCallback) {
          errorCallback(error)
        }
      })

    return this.locale
  }

  tooltip (key, lang) {
    if (this.tooltips.hasOwnProperty(lang)
      && this.tooltips[lang].hasOwnProperty(key)
    ) {
      return this.tooltips[lang][key]
    }

    return ''
  }
}
